const shaka = require('external/shaka-player.ui.debug');

const PlayPauseButton = class extends shaka.ui.Element {
  constructor(parent: typeof PlayPauseButton, controls: ShakaControl) {
    super(parent, controls);

    const CLS_PAUSED = 'paused';
    const CLS_HIDDEN = 'hidden';

    // The actual button that will be displayed
    this.button_ = document.createElement('button') as HTMLButtonElement;
    this.button_.textContent = 'Play/Pause';
    this.button_.classList.add('shaka-play-pause-custom');
    this.button_.classList.add(CLS_PAUSED);
    this.button_.classList.add(CLS_HIDDEN);

    this.parent.appendChild(this.button_);

    const video = this.player.getMediaElement() as HTMLVideoElement;

    video.addEventListener(
      'pause',
      () => {
        this.button_.classList.add(CLS_PAUSED);
      },
      false,
    );

    video.addEventListener(
      'playing',
      () => {
        this.button_.classList.remove(CLS_PAUSED);
      },
      false,
    );

    // remove hidden class - Safari
    if (video.readyState > 0) {
      this.button_.classList.remove(CLS_HIDDEN);
    }

    // remove hidden class - rest of the world
    this.player.addEventListener(
      'loaded',
      () => {
        this.button_.classList.remove(CLS_HIDDEN);
      },
      false,
    );

    this.eventManager.listen(this.button_, 'click', () => {
      controls.onPlayPauseClick_();
    });
  }
};

// Factory that will create a button at run time.
PlayPauseButton.Factory = class {
  create(rootElement, controls) {
    return new PlayPauseButton(rootElement, controls);
  }
};

export default PlayPauseButton;
